export function extractInterfacePageId(input: string): string {
  if (!input) return "";

  // Use regex to match "_PAGE_" followed by digits anywhere in the string
  const match = input.match(/_PAGE_\d+/);

  // Return the matched part or an empty string if no match is found
  return match ? match[0] : "";
}
